import {Log} from '../../shared/log';
import {Injectable} from '@angular/core';
import {AuthHttp, AuthHttpError} from 'angular2-jwt';
import {AppConfig} from '../../app.config';
import {BroadcastService} from '../broadcast/broadcast.service';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {ICoaServiceFieldStructureGroup} from '../../interfaces/ICoaServiceGroupFieldStructure';

const log = new Log('UserService');

@Injectable()
export class SirService {
  private serverUrl = this.appConfig.getValue('endPoint');
  private servicesUrl = this.serverUrl + 'services';

  handleError;

  constructor(
    private authHttp: AuthHttp,
    private appConfig: AppConfig,
    private broadcastService: BroadcastService
  ) {
    this.handleError = this.handleErrorMethod.bind(this);
  }

  getServicesForCoa(): Promise<ICoaServiceFieldStructureGroup[]> {
    return this.authHttp
      .get(this.servicesUrl)
      .toPromise()
      .then(response => response.json() as ICoaServiceFieldStructureGroup[])
      .catch(this.handleError);
  }

  handleErrorMethod(error: any) {
    log.error(error);
    // check for token expiry
    if (error instanceof AuthHttpError) {
      const errorMessage = {
        message: 'Session Error',
        payload: error
      };
      this.broadcastService.broadcast(errorMessage);
    }
    return Promise.reject(error);

  }

}



// WEBPACK FOOTER //
// ./app/services/sir/sir.service.ts